import { render, staticRenderFns } from "./StudentContactBookDataTable.vue?vue&type=template&id=4e326e8f&scoped=true"
import script from "./StudentContactBookDataTable.vue?vue&type=script&lang=js"
export * from "./StudentContactBookDataTable.vue?vue&type=script&lang=js"
import style0 from "./StudentContactBookDataTable.vue?vue&type=style&index=0&id=4e326e8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e326e8f",
  null
  
)

export default component.exports